// Custom select web component.
// 1. Surround your select with <custom-select></custom-select>
// 2. Style classes:
//          a) c-select
//          b) c-select__selected
//          c) c-select__options
//          d) c-select__option
//          e) select-hide


class CustomSelect extends HTMLElement {
  constructor() {
    super()

    this.select = this.querySelector('select')
    this.options = Array.from(this.select.querySelectorAll('option'))

    this.classList.add('c-select')
    // console.log(this.select)
		// console.log(this.select.selectedIndex)
    this.a = document.createElement("DIV");
    this.a.classList.add('c-select__selected')
    this.a.innerHTML = this.select.options[this.select.selectedIndex].innerHTML

    this.a.addEventListener('click', (e) => {
			this.toggleDropdown();
		})

    this.appendChild(this.a)

    this.b = document.createElement("DIV");
    this.b.classList.add('c-select__options', 'select-hide')

    this.options.forEach((item, i) => {
      this.c = document.createElement("DIV");
      this.c.classList.add('c-select__option')
      if(item.disabled == true) {
        this.c.style.opacity = '.7'
        this.c.style.pointerEvents = 'none'
      }

			this.c.innerHTML = item.innerHTML;

      if (item.hasAttribute('selected')) {
        this.c.classList.add('selected-option')
      }

      this.c.addEventListener('click', (e) => {
        this.a.innerHTML = e.target.innerHTML;
        this.a.classList.add('c-select__selected--changed');
        this.select.value = this.options[i].value;
        this.select.dispatchEvent(new Event('change', {
          bubbles: true
        }))

        this.querySelector('.selected-option')?.classList.remove('selected-option')
        e.target.classList.add('selected-option')

        this.toggleDropdown()
      })

      this.b.appendChild(this.c);
    })

    this.appendChild(this.b)

    document.addEventListener('click', (e) => {
      const withinBoundaries = e.composedPath().includes(this)

      if (!withinBoundaries) {
        this.toggleDropdown('close')
      }
    })
  }

  toggleDropdown(setting) {

    if (setting) {
      if (setting === 'close') {
        this.b.classList.add('select-hide')
				this.classList.remove('c-show');
      } else if (setting === 'open') {
        this.b.classList.remove('select-hide')
				this.classList.add('c-show');
      }
    } else {
      this.b.classList.toggle('select-hide')
			this.classList.toggle('c-show');
    }
  }

}

customElements.define('custom-select', CustomSelect);